import { ModalPopInfo, Modal } from "../modules/modal";

const modal = document.querySelector('.js-contact-info');

if (modal && !getCookie("contact-info-modal")) {
	const popInfo = new ModalPopInfo(".js-contact-info");

	document.addEventListener("DOMContentLoaded", () => {
		setTimeout(() => {
			popInfo.open();
			setCookie("contact-info-modal", "1", 1);
		}, 1500);
	});
}

function setCookie(cname, cvalue, exdays) {
	const d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	let expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
	let name = cname + "=";
	let decodedCookie = decodeURIComponent(document.cookie);
	let ca = decodedCookie.split(";");
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) == " ") {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}
